import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "builder" }
const _hoisted_2 = { class: "builder-grid" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.schema, (item, idx) => {
        return (_openBlock(), _createBlock($setup["BuilderSegment"], _mergeProps({
          key: item,
          "vread-from": "valid",
          "onUpdate:valid": $event => (($data.segments_validity[idx]) = $event),
          ref_for: true
        }, item, { onUpdate: $options.onUpdate }), null, 16 /* FULL_PROPS */, ["onUpdate:valid", "onUpdate"]))
      }), 128 /* KEYED_FRAGMENT */)),
      _renderSlot(_ctx.$slots, "last", {}, undefined, true)
    ]),
    (_ctx.$slots.summary)
      ? _renderSlot(_ctx.$slots, "summary", { key: 0 }, undefined, true)
      : (_openBlock(), _createBlock($setup["BuilderSummary"], { key: 1 }))
  ]))
}